import { apiClient } from 'pobble-components/dist/api'

export const apiGetKeys = params => apiClient.get(`/v3/keys`, { params })
